/**
 * 设备能耗统计 — POST /produce/device-energy/statistics/realtime
 */
import request from '@/router/axios'

const API = '/api/produce/device-energy/statistics/realtime'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchDeviceEnergy(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then(unwrap)
}
